var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg"},[_c('div',{staticClass:"uikit-col"},[_c('p',[_vm._v("When you see this symbol "),_c('img',{attrs:{"src":_vm.mfeIcon,"alt":"Event Symbol"}}),_vm._v(" you can book appointments")])])])}
var staticRenderFns = []

export { render, staticRenderFns }